import Vue from 'vue'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_portalvue_c5e6952e from 'nuxt_plugin_portalvue_c5e6952e' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_axios_86133dac from 'nuxt_plugin_axios_86133dac' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_sentryserver_ca9d5224 from 'nuxt_plugin_sentryserver_ca9d5224' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_34f7e566 from 'nuxt_plugin_sentryclient_34f7e566' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_gtm_8add2b00 from 'nuxt_plugin_gtm_8add2b00' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_googleanalytics_d8410e88 from 'nuxt_plugin_googleanalytics_d8410e88' // Source: ./google-analytics.js (mode: 'client')
import nuxt_plugin_ui_1cdb67c5 from 'nuxt_plugin_ui_1cdb67c5' // Source: ../ui/ui.ts (mode: 'all')
import nuxt_plugin_axios_5659cf26 from 'nuxt_plugin_axios_5659cf26' // Source: ../plugins/axios.ts (mode: 'all')
import nuxt_plugin_veevalidate_1a0c172c from 'nuxt_plugin_veevalidate_1a0c172c' // Source: ../plugins/vee-validate.ts (mode: 'all')
import nuxt_plugin_vuecroppie_3ca7044e from 'nuxt_plugin_vuecroppie_3ca7044e' // Source: ../plugins/vue-croppie.ts (mode: 'client')
import nuxt_plugin_rootmounted_c874d56c from 'nuxt_plugin_rootmounted_c874d56c' // Source: ../plugins/root-mounted.ts (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"fade","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  const registerModule = store.registerModule
  store.registerModule = (path, rawModule, options) => registerModule.call(store, path, rawModule, Object.assign({ preserveState: process.client }, options))

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"en"},"title":"CodersRank - The Ultimate Profile For Coders","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width,initial-scale=1,viewport-fit=cover"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:locale","property":"og:locale","content":"en_US"},{"hid":"og:site_name","property":"og:site_name","content":"CodersRank"},{"http-equiv":"Content-Security-Policy","content":"default-src 'self';img-src https: data: 'self';font-src 'self' data: *.gstatic.com *.hotjar.com *.optimonk.com;worker-src 'self' blob: profile.codersrank.io;style-src 'self' 'unsafe-inline' profile.codersrank.io *.github.com *.getbeamer.com *.pingdom.net *.doubleclick.net canny.io *.googleadservices.com *.heapanalytics.com *.licdn.com *.quora.com sentry.io *.sentry-cdn.com *.googleapis.com *.codersrank.io *.google-analytics.com *.googletagmanager.com *.facebook.net *.optimonk.com *.hotjar.com;script-src 'self' 'unsafe-inline' profile.codersrank.io *.github.com *.getbeamer.com *.pingdom.net *.doubleclick.net canny.io *.googleadservices.com *.heapanalytics.com *.licdn.com *.quora.com sentry.io *.sentry-cdn.com *.googleapis.com *.codersrank.io *.google-analytics.com *.googletagmanager.com *.facebook.net *.optimonk.com *.hotjar.com;connect-src profile.codersrank.io *.github.com *.getbeamer.com *.pingdom.net *.doubleclick.net canny.io *.googleadservices.com *.heapanalytics.com *.licdn.com *.quora.com sentry.io *.sentry-cdn.com *.googleapis.com *.codersrank.io *.google-analytics.com *.googletagmanager.com *.facebook.net *.optimonk.com *.hotjar.com wss:\u002F\u002Frealtime.getbeamer.com wss:\u002F\u002F*.hotjar.com;form-action 'self' grpcgateway.codersrank.io;frame-src 'self' *.getbeamer.com *.youtube.com canny.io *.hotjar.com;object-src 'none';base-uri profile.codersrank.io"},{"hid":"itemprop:name","itemprop":"name","content":"CodersRank - The Ultimate Profile For Coders"},{"hid":"og:title","itemprop":"og:title","content":"CodersRank - The Ultimate Profile For Coders"},{"hid":"twitter:title","name":"twitter:title","content":"CodersRank - The Ultimate Profile For Coders"},{"hid":"description","name":"description","content":"Maybe You're an Emerging Talent. Let's Find Out Your Strengths!"},{"hid":"itemprop:description","itemprop":"description","content":"Maybe You're an Emerging Talent. Let's Find Out Your Strengths!"},{"hid":"twitter:description","name":"twitter:description","content":"Maybe You're an Emerging Talent. Let's Find Out Your Strengths!"},{"hid":"og:description","property":"og:description","content":"Maybe You're an Emerging Talent. Let's Find Out Your Strengths!"},{"hid":"itemprop:image","itemprop":"image","content":"https:\u002F\u002Fcodersrank.io\u002Fwp-content\u002Fuploads\u002F2020\u002F06\u002Ffeatured-img-developer-2-1.jpg"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fcodersrank.io\u002Fwp-content\u002Fuploads\u002F2020\u002F06\u002Ffeatured-img-developer-2-1.jpg"},{"hid":"twitter:image","name":"twitter:image","content":"https:\u002F\u002Fcodersrank.io\u002Fwp-content\u002Fuploads\u002F2020\u002F06\u002Ffeatured-img-developer-2-1.jpg"},{"hid":"og:image:width","property":"og:image:width","content":"1200"},{"hid":"og:image:height","property":"og:image:height","content":"630"}],"link":[{"rel":"apple-touch-icon","sizes":"72x72","href":"\u002Fstatic\u002Fapple-touch-icon.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Fstatic\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Fstatic\u002Ffavicon-16x16.png"}],"script":[{"type":"text\u002Fjavascript","src":"\u002Fcookieconsent\u002Fcookieconsent.js"},{"type":"text\u002Fjavascript","src":"\u002Fcrypto\u002Fcrypto-js.min.js"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function (w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e].p&&e[e][p]()))?1:0})(window,'navigator','doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-TDMTGQ6')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-TDMTGQ6&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_portalvue_c5e6952e === 'function') {
    await nuxt_plugin_portalvue_c5e6952e(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_86133dac === 'function') {
    await nuxt_plugin_axios_86133dac(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_ca9d5224 === 'function') {
    await nuxt_plugin_sentryserver_ca9d5224(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_34f7e566 === 'function') {
    await nuxt_plugin_sentryclient_34f7e566(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_8add2b00 === 'function') {
    await nuxt_plugin_gtm_8add2b00(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleanalytics_d8410e88 === 'function') {
    await nuxt_plugin_googleanalytics_d8410e88(app.context, inject)
  }

  if (typeof nuxt_plugin_ui_1cdb67c5 === 'function') {
    await nuxt_plugin_ui_1cdb67c5(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5659cf26 === 'function') {
    await nuxt_plugin_axios_5659cf26(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_1a0c172c === 'function') {
    await nuxt_plugin_veevalidate_1a0c172c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuecroppie_3ca7044e === 'function') {
    await nuxt_plugin_vuecroppie_3ca7044e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_rootmounted_c874d56c === 'function') {
    await nuxt_plugin_rootmounted_c874d56c(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
